import { AxiosInstance } from 'axios';

const check =
  (axios: AxiosInstance) =>
  async (params: {
    action: 'lock' | 'unlock';
    scope: string;
    identifier: string | number;
  }): Promise<{ expires_in: number; status: 'locked' | 'unlocked' | 'failed'; user: string }> => {
    try {
      return await axios.get('transverse/resources/access', { params });
    } catch (error) {
      const response = (error as { response: { data: { status: string; user: string } } })?.response
        .data;
      return Promise.resolve({ expires_in: 0, status: 'failed', user: response.user });
    }
  };

export const ExclusiveAccessService = { check };
